// 2) Third-party library imports
import {
    all,
    call,
    delay,
    fork,
    put,
    takeLatest
} from 'redux-saga/effects';

// 3a) Constants
import {
    API_NAME,
    maxAPIRefetchCount,
    refetchAPIDelay,
} from '../../config/config';

// 3d) Utility functions
import { checkShouldRequestRefetch } from '../../utils/commonFunctions';
import { DynamicObject } from '../../utils/commonInterfaces';
import { post } from 'src/api';

// 3e) Redux actions
import {
    companyInviteCreateAction,
    companyInviteLinkAction,
    companyInviteValidateAction
} from './inviteSlice';

let refetchCount = 0;

function* handleCompanyInviteCreate({ payload: sagaPayload }: any) {
    const { payload, callback } = sagaPayload;
    try {
        // To call async functions, use redux-saga's `call()`.
        const { body } = yield call(post, {
            apiName: API_NAME,
            path: '/company/invite/create',
            options: {
                body: payload,
            }
        });
        const response: DynamicObject = yield body.json();
        response.IsSuccess = true;
        
        refetchCount = 0;

        if (callback) {
            callback(response);
        }
    }
    catch (err) {
        if (err instanceof Error) {
            console.log('Error', err);
        }
        else {
            console.error('An unknown error occured.');
        }

        if (
            refetchCount <= maxAPIRefetchCount &&
            checkShouldRequestRefetch(err)
        ) {
            refetchCount++;

            yield delay(refetchAPIDelay);
            yield put(companyInviteCreateAction(payload, callback));
        }
        else {
            if (callback) {
                let returnData: any;

                if (err instanceof Error && 'response' in err && (err as any).response.body) {
                    returnData = JSON.parse((err as any).response.body);
                } else if (err instanceof Error) {
                    returnData = { Messages: [err.message] };
                } else {
                    returnData = { Messages: ['An unknown error occurred.'] };
                }

                returnData.IsSuccess = false;
                callback(returnData);
            }
        }
    }
}

function* handleCompanyInviteValidate({ payload: sagaPayload }: any) {
    const { inviteToken, callback } = sagaPayload;
    try {
        // To call async functions, use redux-saga's `call()`.
        const { body } = yield call(post, {
            apiName: API_NAME,
            path: '/company/invite/validate',
            options: {
                body: {
                    InviteToken: inviteToken,
                }
            }
        });
        const response: DynamicObject = yield body.json();
        if (callback) {
            callback(response);
        }
    }
    catch (err) {
        if (callback) {
            let returnData: any;

            if (err instanceof Error && 'response' in err && (err as any).response.body) {
                returnData = JSON.parse((err as any).response.body);
            } else if (err instanceof Error) {
                returnData = { Messages: [err.message] };
            } else {
                returnData = { Messages: ['An unknown error occurred.'] };
            }

            returnData.IsSuccess = false;
            callback(returnData);
        }


        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occurred.');
        }
    }
}

function* handleCompanyInviteLink({ payload: sagaPayload }: any) {
    const { inviteToken, callback } = sagaPayload;

    try {
        // To call async functions, use redux-saga's `call()`.
        const { body } = yield call(post, {
            apiName: API_NAME,
            path: '/company/invite/link',
            options: {
                body: {
                    Token: inviteToken,
                },
            }
        });
        const response: DynamicObject = yield body.json();
        response.IsSuccess = true;

        if (callback) {
            callback(response);
        }
    }
    catch (err) {
        if (callback) {
            let returnData: any;

            if (err instanceof Error && 'response' in err && (err as any).response.body) {
                returnData = JSON.parse((err as any).response.body);
            } else if (err instanceof Error) {
                returnData = { Messages: [err.message] };
            } else {
                returnData = { Messages: ['An unknown error occurred.'] };
            }

            returnData.IsSuccess = false;
            callback(returnData);
        }


        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occurred.');
        }
    }
}

// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchCompanyInviteCreateRequest() {
    yield takeLatest(
        companyInviteCreateAction.type,
        handleCompanyInviteCreate
    );
}

function* watchCompanyInviteValidateRequest() {
    yield takeLatest(
        companyInviteValidateAction.type,
        handleCompanyInviteValidate
    );
}

function* watchCompanyInviteLinkRequest() {
    yield takeLatest(
        companyInviteLinkAction.type,
        handleCompanyInviteLink
    );
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* inviteSaga() {
    yield all([
        fork(watchCompanyInviteCreateRequest),
        fork(watchCompanyInviteValidateRequest),
        fork(watchCompanyInviteLinkRequest),
    ]);
}

export default inviteSaga;
